import React from 'react';
import { Cookie, X, Shield } from 'lucide-react';
import { useConsent } from '../contexts/ConsentContext';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

export const ConsentBanner = () => {
  const { showBanner, acceptConsent, rejectConsent } = useConsent();

  if (!showBanner) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40" />
      
      {/* Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-slide-in-right">
        <div className="container-custom">
          <div className="glass-card p-6 sm:p-8 max-w-4xl mx-auto border-2 border-primary/20">
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
              {/* Icon */}
              <div className="flex-shrink-0">
                <div className="p-3 glass rounded-xl">
                  <Cookie className="w-8 h-8 text-primary" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-grow">
                <h3 className="text-xl font-bold mb-2 flex items-center gap-2">
                  <Shield className="w-5 h-5 text-primary" />
                  Your Privacy Matters
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                  We use <strong>essential cookies</strong> to remember your theme preference.
                  We also display <strong>third-party ads (Google AdSense)</strong> to keep this
                  service free. Ad networks may use cookies for personalized advertising.
                </p>
                <p className="text-foreground text-sm font-semibold mb-3">
                  Important: We never collect or store your tool data. All processing happens
                  locally in your browser.
                </p>
                <div className="flex flex-wrap gap-2 text-xs">
                  <Link to="/privacy" className="text-primary hover:underline">
                    Privacy Policy
                  </Link>
                  <span className="text-muted-foreground">•</span>
                  <Link to="/disclaimer" className="text-primary hover:underline">
                    Advertising Disclaimer
                  </Link>
                  <span className="text-muted-foreground">•</span>
                  <Link to="/terms" className="text-primary hover:underline">
                    Terms of Service
                  </Link>
                </div>
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                <Button
                  onClick={acceptConsent}
                  size="lg"
                  className="hover:glow-primary w-full sm:w-auto"
                >
                  Accept All
                </Button>
                <Button
                  onClick={rejectConsent}
                  variant="outline"
                  size="lg"
                  className="glass w-full sm:w-auto"
                >
                  Reject Non-Essential
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsentBanner;
